module.exports = __webpack_public_path__ + "static/media/VectorBulding.f521891b.svg";